import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import i18next from 'src/utils/i18next';
import { Box, Drawer, Hidden, makeStyles } from '@material-ui/core';
import { MenuContent } from './components';

const useStyles = makeStyles(() => ({
    root: {
        '@media print': {
            display: 'none',
        },
    },
    mobileDrawer: {
        width: 275,
    },
    desktopDrawer: {
        width: 275,
        top: 80,
        height: 'calc(100% - 80px)',
        border: 'none',
    },
}));

const NavBar = ({ onMobileClose, openMobile }) => {
    const classes = useStyles();
    const location = useLocation();

    useEffect(() => {
        let language;
        if (localStorage.getItem('i18nextLng'))
            language = localStorage.getItem('i18nextLng');
        else language = 'en';

        i18next.changeLanguage(language);
    }, []);

    useEffect(() => {
        if (openMobile && onMobileClose) onMobileClose();
    }, [location.pathname]);

    return (
        <Box className={classes.root}>
            <Hidden lgUp>
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.mobileDrawer }}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant="temporary"
                >
                    <MenuContent />
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.desktopDrawer }}
                    open
                    variant="persistent"
                >
                    <MenuContent />
                </Drawer>
            </Hidden>
        </Box>
    );
};

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool,
};

export default NavBar;
